import Cookies from "js-cookie";
import axios from "../utils/axios";

export async function getRules() {
    const {data} = await axios.get("/bookdeclare/zh");
    return data;
}
export function getSwipes() {
    const school = JSON.parse(Cookies.get("school")).school;
    return [{
            url: `/banner/${school}/home1.jpg`,
        },
        {
            url: `/banner/${school}/home2.jpg`,
        },
        {
            url: `/banner/${school}/home3.jpg`,
        },
    ];
}
export function getNotices() {
    return axios.get("/noticeinfo");
}
export function getNoticeDetail(id) {
    return axios.get(`/noticeinfo?id=${id}`);
}
export function getEvents() {
    return axios.get("/activityinfo");
}
export function getEventDetail(id) {
    return axios.get(`/activityinfo?id=${id}`);
}
export function getAllLibraries() {
    return axios.get("/schoollist");
}
export function getOpenDays(id) {
    return axios.get(`/areadays/${id}`);
}
export function getRoomOpenDays() {
    return axios.get(`/spacesbookday`);
}
export function getOpenDaysByRoom(roomId) {
    return axios.get(`/space_days/${roomId}`);
}
export function getAreas(params) {
    return axios.get("/v3areas", { params });
}
export function getRooms(params) {
    return axios.get(`/v3spaces`, {params});
}
export function getRoom(libId, params) {
    return axios.get(`/studyinfo/${libId}`, {params});
}
export function getSeats(params) {
    return axios.get("/spaces_old", { params });
}
export function bookSeat(id, params) {
    return axios.post(`/spaces/${id}/book`, params, { headers: { 'content-type': 'application/x-www-form-urlencoded' } });
}
export function bookRoom(id, params) {
    return axios.post(`/spaces/${id}/studybook`, params, { headers: { 'content-type': 'application/x-www-form-urlencoded' } });
}
export function getMyBookings(params) {
    return axios.get(`/profile/books`, { params });
}
export function cancelBooking(id, params) {
    return axios.post(`/profile/books/${id}`, params, { headers: { 'content-type': 'application/x-www-form-urlencoded' } });
}
export function getMyViolations(params) {
    return axios.get(`/profile/reneges`, { params });
}
export function getMyEvents(params) {
    return axios.get(`/profile/activities`, { params });
}
export function applyEvent(id, params) {
    return axios.post(`/activities/${id}/application`, params);
}
export function signInEvent() {
    return axios.get(`/activities_signin`);
}
export function getFavoriteBookings(userid) {
    return axios.get(`/recentbook/${userid}`);
}
export async function getCurrentUse(params) {
    const {data} = await axios.get(`/currentuse`, { params });
    return data;
}
export function scanBook(params) {
    return axios.get(`/v3qrbookcheck`, {params});
}
export function changeBook(id, params) {
    return axios.post(`/profile/books/${id}`, params, { headers: { 'content-type': 'application/x-www-form-urlencoded' } });
}
export function changeBookForScan(id, params) {
    return axios.post(`/profile/touchqrbooks/${id}`, params, { headers: { 'content-type': 'application/x-www-form-urlencoded' } });
}
export function changeSeat(params) {
    return axios.get('/v3qrchangeseat', {params});
}
export async function getSysConfig() {
    const {data} = await axios.get('/v3myyuyuebutton');
    return data;
}
export function getMember(userid, params) {
    return axios.get(`/users/${userid}`, {params});
}
export async function getOpenTime() {
    const {data:{list:beginTime}} = await axios.get('/configs/WEBBOOK_BEGINTIME');
    const {data:{list:endTime}} = await axios.get('/configs/WEBBOOK_ENDTIME');
    return {beginTime,endTime};
}
export async function getServerTime() {
    const {data} = await axios.get('/v3qrtime');
    return data;
}
export function getEntranceSchools() {
    return axios.get('/v3entranceschoollist');
}
export function getEntranceDates(params) {
    return axios.get('/v3entrancedatelist', {params});
}
export function getEntrances(params) {
    return axios.get('/v3entrancelist', {params});
}
export function applyEntrance(id, params) {
    return axios.post(`/activities/${id}/application2`, params, { headers: { 'content-type': 'application/x-www-form-urlencoded' } });
}
export function cancelEntrance(id, params) {
    return axios.post(`/activities/${id}/quit`, params, { headers: { 'content-type': 'application/x-www-form-urlencoded' }});
}
export function getMyEntrances(params) {
    return axios.get(`/v3activities_yuyuelist`, {params})
}